import type { Problem } from 'store/types/common';
import { Button, Icon, Label } from '@gravity-ui/uikit';
import { ChevronRight } from '@gravity-ui/icons';
import { ScoreLabel } from './blank-problem-score';

import styles from './styles.module.scss';

interface ClientBlankEstimateBlockProps {
	problem: Problem;
	handleOpenSheet: (problem: Problem, sheetType: 'execution' | 'satisfaction') => void;
}

export const ClientBlankEstimateBlock = ({ problem, handleOpenSheet }: ClientBlankEstimateBlockProps) => {
	return (
		<div key={problem.id} className={styles.problem}>
			<div className={styles.problem__subsection}>
				<div className={styles.problem__subsection__importance}>
					<span> Подраздел</span>
					<Label theme="normal">Важность {problem.importance}</Label>
				</div>
				<p>{problem.subsection.sectionName}</p>
			</div>

			<div className={styles.problem__information}>
				<span>Описание проблемы</span>
				<div className={styles.problem__information__text}>
					<p>{problem.text}</p>
					{problem.estimate && problem.estimate.length > 0 && (
						<Label theme="clear">
							МКФ-код: {`${problem.estimate[0].prefix} ${problem.estimate[0].domainCode}`}
						</Label>
					)}
				</div>
			</div>

			<div className={styles.problem__btns}>
				<Button
					onClick={() => handleOpenSheet(problem, 'execution')}
					className={styles.problem__btns__btn_execution}
					size="l"
					view="outlined"
				>
					Выполнение
					<ScoreLabel value={problem.execution} />
					<Icon data={ChevronRight} size={18} />
				</Button>
				<Button
					onClick={() => handleOpenSheet(problem, 'satisfaction')}
					className={styles.problem__btns__btn_satisfaction}
					size="l"
				>
					Удовлетворённость
					<ScoreLabel value={problem.satisfaction} />
					<Icon data={ChevronRight} size={18} />
				</Button>
			</div>
		</div>
	);
};
